import sanitizeHtml from "@gpp-ui/html-sanitizer";
export const defaultConfig = {
  stripIgnoreTag: true,
  stripIgnoreTagBody: ["script"],
  whiteList: sanitizeHtml.getDefaultWhiteList()
};
Object.keys(defaultConfig.whiteList ?? {}).forEach((tag) => {
  defaultConfig.whiteList[tag]?.push("class");
  defaultConfig.whiteList[tag]?.push("style");
});
let globalSanitizeConfig = { ...defaultConfig };
export function getGlobalSanitizeConfig() {
  return globalSanitizeConfig;
}
export function setGlobalSanitizeConfig(newConfig) {
  if (!newConfig || typeof newConfig !== "object") {
    console.warn("Invalid sanitization config update. Expected an object.");
    return;
  }
  globalSanitizeConfig = { ...globalSanitizeConfig, ...newConfig };
}
